import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';
import CustomButton from './CustomButton';
import MailOutlineIcon from '@material-ui/icons/MailOutline';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function GuideService() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">

        <a id="service-nie" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            ＮＩＥ
          </Typography>
          　NIEは、学校現場などで新聞を教材として活用する活動です。デーリー東北新聞社では、学校の要望に応じて記者経験者らを講師として派遣する事業を無償で行っているほか、八戸市教育委員会の「ひらく・楽しむ」新聞活用事業にも協力し、市立小・中学校への出前講座も実施しています。お問い合わせなどはデーリー東北新聞社コミュニティー事業部まで。電話：０１７８（８０）７２９９（平日午前９時半～午後５時）
          <dl>
            <dt>※NIEとは</dt>
            <dd>
            　（Newspaper in Education＝「教育に新聞を」の意味、エヌ・アイ・イーと読みます）　１９３０年代にアメリカで始まり、日本では８５年、静岡県で開かれた新聞大会で提唱されました。教育界と新聞界が協力し、社会性豊かな青少年の育成や、活字文化と民主主義社会の発展などを目的に全国で実施されています。
            </dd>
          </dl>
        </Box>

        <a id="service-support" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            後援願い
          </Typography>
          　デーリー東北新聞社にスポーツ、芸術、文化等の催し物の名義後援を希望される場合は、下記の「詳細」をご覧いただき、必要事項を記入の上、提出してください。<br />
          　なお、承諾は以下の場合とさせていただきます。<br />
          <ul className="my-3">
            <li>地域住民及び読者の福祉、文化などの向上に寄与するもの</li>
            <li>公序良俗・法律に反しないこと</li>
            <li>公益性があること</li>
            <li>その他、弊社が適当と判断した事業であること</li>
          </ul>
          {/*
          　後援を希望する方は、下記の「詳細」よりお進みいただき、申請書をダウンロードして必要事項を記入の上、提出してください。<br/>
          */}
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="/support" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  詳　細
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

        {/* <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            デリオンくらぶ
          </Typography>
          　デーリー東北読者クラブは２０１８年１１月１日より、「デリオンくらぶ」にリニューアルしました。<br/>
          　「デーリー東北」の紙面からひろがる、“ちょっと得する”毎日を皆さんにお届けします。<br/>
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="https://delion-dt.com/" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  詳　細
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box> */}

        <a id="service-tour" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            会社見学
          </Typography>
          　デーリー東北新聞社は、より新聞に親しんでいただくため、会社見学・印刷工場見学を受け入れています。事前予約が必要ですので、先に電話で見学希望日をご確認の上、下記の「詳細」をご覧いただき、お申し込みください。<br />
          　事前予約は見学希望日の１カ月前までにお願いします。<br />
          　なお、弊社の都合により見学の受け入れをお断りする場合もございます。<br />

          {/*
          <dl>
            <dt>（１）正面玄関前（悪天候時は（４）の印刷工場内）で記念写真撮影</dt>
            <dd>
              本ホームページと翌日の本紙地域面に掲載いたします。
            </dd>
            <dt>（２）６階メディアホールでＤＶＤ上映</dt>
            <dd>
              新聞ができるまでの流れを説明した弊社の紹介映像を鑑賞します。
            </dd>
            <dt>（３）４階編集局の見学</dt>
            <dd>
              新聞製作の心臓部である職場を見学します。
            </dd>
            <dt>（４）印刷工場の見学</dt>
            <dd>
              本社に隣接する工場を見学します。（ただし輪転機は稼働しておりません）
            </dd>
          </dl>
          */}
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="/tour" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  詳　細
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <a id="service-photoprint" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            掲載写真販売
          </Typography>
          　デーリー東北新聞社ではデーリー東北紙面に掲載された写真のプリントや、写真に記事・見出しなどを入れて再編集した「記事付き写真」、誕生日や結婚記念日などご希望の日付の紙面を縮小コピーしラミネート加工した「メモリアル新聞」など写真・紙面の有料サービスを行っております。思い出づくりや掲載記念、贈り物などにご活用ください。<br/>
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="/printservice" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  詳　細
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <a id="service-backnumber" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            バックナンバー販売
          </Typography>
          　「子供が新聞に載った！」<br/>
          　「アイドルの記事が載った新聞が欲しい」……<br/>
          　保存用にバックナンバーをご購入ください
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="mailto:backnumber@daily-tohoku.co.jp" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  詳　細
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
          <div className="border-dark bg-white p-3">
            <Typography className="font-weight-bold line180" variant="subtitle1" component="h2">
              <PhoneEnabledIcon /> フリーダイヤル　0120-365-339<br />
              <MailOutlineIcon /> 電子メール　　　<a href="mailto:hanbai@daily-tohoku.co.jp">hanbai@daily-tohoku.co.jp</a><br />
            </Typography>
          </div>
        </Box>
      </div>
    </div>
  );
}

export default GuideService;
